import { fetchSwiper } from '../dynamic-modules';

function init() {
    const containers = Array.from(document.querySelectorAll('.js-inner-slider'));

    containers.forEach((container) => {
        let swiper;
        let slides = [];
        const paginationContainer = container
            .closest('.styler-slide-container')
            ?.querySelector('.js-catalog-slider-pagination');
        const wrapper = Array.from(container.children).find((el) => el.classList.contains('swiper-wrapper'));

        if (wrapper) {
            const wrapperChildren = Array.from(wrapper.children);
            slides = wrapperChildren.filter((el) => el.classList.contains('swiper-slide'));
        }

        async function _init() {
            const { default: Swiper, Pagination, EffectFade, Lazy } = await fetchSwiper();
            Swiper.use(Pagination);
            Swiper.use(EffectFade);
            Swiper.use(Lazy);

            swiper = new Swiper(container, {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                centeredSlides: true,
                noSwipingSelector: '.swiper--no-swiping',
                slidesPerView: 1,
                edgeSwipeThreshold: 40,
                speed: 1000,
                pagination: {
                    el: paginationContainer,
                    type: 'bullets',
                    clickable: true,
                    renderBullet: (index, className) => `
                        <button class="slider-pagination__bullet ${className}"></button>
                    `,
                },
                lazy: {
                    loadPrevNext: true,
                },
            });
        }

        function _destroy() {
            swiper.destroy();
        }

        function _onResize() {
            if (slides.length > 1) {
                if (window.matchMedia('(max-width: 1024px)').matches) {
                    if (swiper) {
                        _destroy();
                    }
                } else if (!swiper) {
                    _init();
                }
            }
        }

        _onResize();
        window.addEventListener('resize', _onResize);
    });
}

export default { init };
